const countriesAndRegions: any = {
  countries: {
    AF: "Afghanistan",
    AX: "Îles d`Aland",
    AL: "Albanie",
    DZ: "Algérie",
    AS: "Samoa Américaines",
    AD: "Andorre",
    AO: "Angola",
    AI: "Anguilla",
    AQ: "Antarctique",
    AG: "Antigua-et-Barbuda",
    AR: "Argentine",
    AM: "Arménie",
    AW: "Aruba",
    AU: "Australie",
    AT: "Autriche",
    AZ: "Azerbaïdjan",
    BS: "Bahamas",
    BH: "Bahreïn",
    BD: "Bangladesh",
    BB: "Barbade",
    BY: "Biélorussie",
    BE: "Belgique",
    BZ: "Bélize",
    BJ: "Bénin",
    BM: "Bermudes",
    BT: "Bhoutan",
    BO: "Bolivie",
    BA: "Bosnie-Herzégovine",
    BW: "Botswana",
    BV: "Île Bouvet",
    BR: "Brésil",
    IO: "Territoire Britannique de l`Océan Indien",
    VG: "Îles vierges britanniques",
    BN: "Brunei",
    BG: "Bulgarie",
    BF: "Burkina Faso",
    BI: "Burundi",
    KH: "Cambodge",
    CM: "Cameroun",
    CA: "Canada",
    CV: "Cap-Vert",
    BQ: "Caraïbes néerlandaises",
    KY: "Îles Caïmans",
    CF: "République centrafricaine",
    TD: "Tchad",
    CL: "Chili",
    CN: "Chine",
    CX: "Île Christmas",
    CC: "Îles Cocos (Keeling)",
    CO: "Colombie",
    KM: "Comores",
    CG: "Congo (Brazzaville)",
    CD: "Congo (Kinshasa)",
    CK: "Îles Cook",
    CR: "Costa Rica",
    HR: "Croatie",
    CU: "Cuba",
    CW: "Curaçao",
    CY: "Chypre",
    CZ: "République tchèque",
    DK: "Danemark",
    DJ: "Djibouti",
    DM: "Dominique",
    DO: "République dominicaine",
    EC: "Équateur",
    EG: "Égypte",
    SV: "El Salvador",
    GQ: "Guinée équatoriale",
    ER: "Érythrée",
    EE: "Estonie",
    ET: "Éthiopie",
    FK: "îles des Falkland",
    FO: "Îles Féroé",
    FJ: "Fidji",
    FI: "Finlande",
    FR: "France",
    GF: "Guyane française",
    PF: "Polynésie Française",
    TF: "Terres australes françaises",
    GA: "Gabon",
    GM: "Gambie",
    GE: "Géorgie",
    DE: "Allemagne",
    GH: "Ghana",
    GI: "Gibraltar",
    GR: "Grèce",
    GL: "Groenland",
    GD: "Grenade",
    GP: "Guadeloupe",
    GU: "Guam",
    GT: "Guatemala",
    GG: "Guernesey",
    GN: "Guinée",
    GW: "Guinée-Bissau",
    GY: "Guyane",
    HT: "Haïti",
    HM: "Île Heard et îles McDonald",
    HN: "Honduras",
    HK: "Hong Kong",
    HU: "Hongrie",
    IS: "Islande",
    IN: "Inde",
    ID: "Indonésie",
    IR: "Iran",
    IQ: "Irak",
    IE: "Irlande",
    IM: "Île de Man",
    IL: "Israël",
    IT: "Italie",
    CI: "Côte d`Ivoire",
    JM: "Jamaïque",
    JP: "Japon",
    JE: "Jersey",
    JO: "Jordanie",
    KZ: "Kazakhstan",
    KE: "Kenya",
    KI: "Kiribati",
    KW: "Koweït",
    KG: "Kirghizistan",
    LA: "Laos",
    LV: "Lettonie",
    LB: "Liban",
    LS: "Lesotho",
    LR: "Libéria",
    LY: "Libye",
    LI: "Liechtenstein",
    LT: "Lituanie",
    LU: "Luxembourg",
    MO: "Chine",
    MK: "Macédoine",
    MG: "Madagascar",
    MW: "Malawi",
    MY: "Malaisie",
    MV: "Maldives",
    ML: "Mali",
    MT: "Malte",
    MH: "Îles Marshall",
    MQ: "Martinique",
    MR: "Mauritanie",
    MU: "Île Maurice",
    YT: "Mayotte",
    MX: "Mexique",
    FM: "Micronésie",
    MD: "Moldavie",
    MC: "Monaco",
    MN: "Mongolie",
    ME: "Monténégro",
    MS: "Montserrat",
    MA: "Maroc",
    MZ: "Mozambique",
    MM: "Myanmar",
    NA: "Namibie",
    NR: "Nauru",
    NP: "Népal",
    NL: "Pays-Bas",
    AN: "Antilles Néerlandaises",
    NC: "Nouvelle-Calédonie",
    NZ: "Nouvelle-Zélande",
    NI: "Nicaragua",
    NE: "Niger",
    NG: "Nigeria",
    NU: "Niue",
    NF: "Île Norfolk",
    MP: "Îles Mariana du Nord",
    KP: "Corée du nord",
    NO: "Norvège",
    OM: "Oman",
    PK: "Pakistan",
    PW: "Palaos",
    PS: "Territoire palestinien",
    PA: "Panama",
    PG: "Papouasie-Nouvelle-Guinée",
    PY: "Paraguay",
    PE: "Pérou",
    PH: "Philippines",
    PN: "Pitcairn",
    PL: "Pologne",
    PT: "Portugal",
    PR: "Porto Rico",
    QA: "Qatar",
    RE: "Réunion",
    RO: "Roumanie",
    RU: "Russie",
    RW: "Rwanda",
    BL: "Saint Barthélémy",
    SH: "Sainte-Hélène",
    KN: "Saint-Christophe-et-Niévès",
    LC: "Sainte-Lucie",
    MF: "Saint Martin (partie française)",
    PM: "Saint-Pierre-et-Miquelon",
    VC: "Saint-Vincent-et-les Grenadines",
    WS: "Samoa",
    SM: "Saint-Marin",
    ST: "Sao Tomé-et-Principe",
    SA: "Arabie saoudite",
    SN: "Sénégal",
    RS: "Serbie",
    SC: "Seychelles",
    SL: "Sierra Leone",
    SG: "Singapour",
    SX: "Saint Martin (Néerlandais)",
    SK: "Slovaquie",
    SI: "Slovénie",
    SB: "Îles Salomon",
    SO: "Somalie",
    ZA: "Afrique du Sud",
    GS: "Géorgie du Sud et îles Sandwich du Sud",
    KR: "Corée du Sud",
    SS: "Soudan du Sud",
    ES: "Espagne",
    LK: "Sri Lanka",
    SD: "Soudan",
    SR: "Suriname",
    SJ: "Svalbard et Jan Mayen",
    SZ: "Swaziland",
    SE: "Suède",
    CH: "Suisse",
    SY: "Syrie",
    TW: "Taiwan",
    TJ: "Tadjikistan",
    TZ: "Tanzanie",
    TH: "Thaïlande",
    TL: "Timor-Leste",
    TG: "Togo",
    TK: "Tokelau",
    TO: "Tonga",
    TT: "Trinité-et-Tobago",
    TN: "Tunisie",
    TR: "Turquie",
    TM: "Turkménistan",
    TC: "Îles Turques et Caïques",
    TV: "Tuvalu",
    VI: "Îles vierges américaines",
    UG: "Ouganda",
    UA: "Ukraine",
    AE: "Émirats arabes unis",
    GB: "Royaume-Uni",
    US: "USA",
    UM: "Îles mineures éloignées des États-Unis",
    UY: "Uruguay",
    UZ: "Ouzbékistan",
    VU: "Vanuatu",
    VA: "Vatican",
    VE: "Venezuela",
    VN: "Vietnam",
    WF: "Wallis et Futuna",
    EH: "Sahara Occidental",
    YE: "Yémen",
    ZM: "Zambie",
    ZW: "Zimbabwe ",
  },
  regions: {
    "123": "Andalousie",
    "124": "Aragon",
    "125": "Asturies",
    "126": "Îles baléares",
    "127": "Pays basque",
    "128": "Îles canaries",
    "129": "Cantabrie",
    "130": "Castille-et-Léon",
    "131": "Castille-La Manche",
    "132": "Catalogne",
    "133": "Ceuta",
    "134": "Estrémadure",
    "135": "Galice",
    "136": "La Rioja (Espagne)",
    "137": "Madrid",
    "138": "Melilla",
    "139": "Murcie",
    "140": "Navarre",
    "141": "Communauté de Valence",
    "142": "Attique",
    "143": "Grèce centrale",
    "144": "Macédoine centrale",
    "145": "Crête",
    "146": "Macédoine orientale et Thrace",
    "147": "Épire",
    "148": "Îles ioniennes",
    "149": "Nord de l`égée",
    "150": "Péloponnèse",
    "151": "Sud de l`égée",
    "152": "Théssalie",
    "153": "Grèce occidentale",
    "154": "Macédoine occidentale",
    "155": "Aveiro",
    "156": "Beja",
    "157": "Braga",
    "158": "Bragance",
    "159": "Castelo Branco",
    "160": "Coimbra",
    "161": "Évora",
    "162": "Faro",
    "163": "Guarda",
    "164": "Leiria",
    "165": "Lisbonne",
    "166": "Portalegre",
    "167": "Porto",
    "168": "Santarm",
    "169": "Santarem",
    "170": "Viana do Castelo",
    "171": "Vila Real",
    "172": "Viseu",
    "173": "Nord",
    "174": "Sud",
    "175": "Centre",
    "176": "Îles Andaman-et-Nicobar",
    "177": "Andhra Pradesh",
    "178": "Arunachal Pradesh",
    "179": "Assam",
    "180": "Bihar",
    "181": "Chandigarh",
    "182": "Chhattisgarh",
    "183": "Dadra et Nagar Haveli",
    "184": "Daman et Diu",
    "185": "Goa",
    "186": "Gujarat",
    "187": "Haryanav",
    "188": "Himachal Pradesh",
    "189": "Jammu-et-Cachemire",
    "190": "Jharkhand",
    "191": "Karnataka",
    "192": "Kerala",
    "193": "Lakshadweep",
    "194": "Madhya Pradesh",
    "195": "Maharashtra",
    "196": "Manipur",
    "197": "Meghalaya",
    "198": "Mizoram",
    "199": "Nagaland",
    "200": "Territoire de la capitale nationale de Delhi",
    "201": "Odisha",
    "202": "Puducherry",
    "203": "Pendjab",
    "204": "Rajasthan",
    "205": "Sikkim",
    "206": "Tamil Nadu",
    "207": "Telangana",
    "208": "Tripura",
    "209": "Uttar Pradesh",
    "210": "Uttarakhand",
    "211": "Bengale occidental",
    "212": "Nouvelle-Galles du Sud",
    "213": "Queensland",
    "214": "Australie du Sud",
    "215": "Tasmanie",
    "216": "Victoria",
    "217": "Australie Occidentale",
    "218": "Territoire du Nord",
    "219": "Île du Pacifique",
    "220": "PNG",
    "221": "Adana",
    "222": "Adiyaman",
    "223": "Afyonkarahisar",
    "224": "Agri",
    "225": "Aksaray",
    "226": "Amasya",
    "227": "Ankara",
    "228": "Antalya",
    "229": "Ardahan",
    "230": "Artvin",
    "231": "Aydin",
    "232": "Balikesir",
    "233": "Bartin",
    "234": "Batman",
    "235": "Bayburt",
    "236": "Bilecik",
    "237": "Bingöl",
    "238": "Bitlis",
    "239": "Bolu",
    "240": "Burdur",
    "241": "Bursa",
    "242": "Çanakkale",
    "243": "Çankiri",
    "244": "Çorum",
    "245": "Denizli",
    "246": "Diyarbakir",
    "247": "Düzce",
    "248": "Edirne",
    "249": "Elazığ",
    "250": "Erzincan",
    "251": "Erzurum",
    "252": "Eskişehir",
    "253": "Gaziantep",
    "254": "Giresun",
    "255": "Gümüşhane",
    "256": "Hakkari",
    "257": "Hatay",
    "258": "Iğdır",
    "259": "Isparta",
    "260": "Istanbul",
    "261": "Kahramanmaras",
    "262": "Karabük",
    "264": "Karaman",
    "265": "Kars",
    "266": "Kastamonu",
    "267": "Kayseri",
    "268": "Kilis",
    "269": "Kirikkale",
    "270": "Kirklareli",
    "271": "Kirsehir",
    "272": "Kocaeli",
    "273": "Konya",
    "274": "Kütahya",
    "275": "Malatya",
    "276": "Manisa",
    "277": "Mardin",
    "278": "Mersin",
    "279": "Mugla",
    "280": "Mus",
    "281": "Nevsehir",
    "282": "Nigde",
    "283": "Ordu",
    "284": "Osmaniye",
    "285": "Rize",
    "286": "Sakarya",
    "287": "Samsun",
    "288": "Sanliurfa",
    "289": "Siirt",
    "290": "Sinop",
    "291": "Sırnak",
    "292": "Sivas",
    "293": "Tekirdag",
    "294": "Tokat",
    "295": "Trabzon",
    "296": "Tunceli",
    "297": "Usak",
    "298": "Van",
    "299": "Yalova",
    "300": "Yozgat",
    "301": "Basse-Californie",
    "302": "Basse-Californie du Sud",
    "303": "Chihuahua",
    "304": "Durango",
    "305": "Sinaloa",
    "306": "Sonora",
    "307": "Coahuila",
    "308": "Nuevo",
    "309": "Leon",
    "310": "Tamaulipas",
    "311": "Aguascalientes",
    "312": "Guanajuato",
    "313": "Querétaro",
    "314": "San Luis Potosí",
    "315": "Zacatecas",
    "316": "District Fédéral",
    "317": "Mexico",
    "318": "Morelos",
    "319": "Colima",
    "320": "Jalisco",
    "321": "Michoacán",
    "322": "Nayarit",
    "323": "Hidalgo",
    "324": "Puebla",
    "325": "Tlaxcala",
    "326": "Veracruz",
    "327": "Campeche",
    "328": "Quintana Roo",
    "329": "Tabasco",
    "330": "Yucatan",
    "331": "Chiapas",
    "332": "Guerrero",
    "333": "Oaxaca",
    "334": "Colombie-Britannique",
    "335": "Alberta",
    "336": "Saskatchewan",
    "337": "Manitoba",
    "338": "Ontario",
    "339": "Québec",
    "340": "Nouveau-Brunswick",
    "341": "Île-du-Prince-Édouard",
    "342": "Nova Scotia",
    "343": "Terre-Neuve-et-Labrador",
    "344": "Yukon",
    "345": "Nord-Est",
    "346": "Territoires",
    "347": "Nunavut",
    "348": "Alabama",
    "349": "Alaska",
    "350": "Arizona",
    "351": "Arkansas",
    "352": "Californie",
    "353": "Colorado",
    "354": "Connecticut",
    "355": "Delaware",
    "356": "Floride",
    "357": "Géorgie",
    "358": "Hawaï",
    "359": "Idaho",
    "360": "Illinois",
    "361": "Indiana",
    "362": "Iowa",
    "363": "Kansas",
    "364": "Kentucky",
    "365": "Louisiane",
    "366": "Maine",
    "367": "Maryland",
    "368": "Massachusetts",
    "369": "Michigan",
    "370": "Minnesota",
    "371": "Mississippi",
    "372": "Missouri",
    "373": "Montana",
    "374": "Nebraska",
    "375": "Nevada",
    "376": "New Hampshire",
    "377": "New Jersey",
    "378": "Nouveau-Mexique",
    "379": "New York",
    "380": "Caroline du Nord",
    "381": "Nord",
    "382": "Dakota",
    "383": "Ohio",
    "384": "Oklahoma",
    "385": "Oregon",
    "386": "Pennsylvanie",
    "387": "Rhode Island",
    "388": "Caroline du Sud",
    "389": "Dakota du Sud",
    "390": "Tennessee",
    "391": "Texas",
    "392": "Utah",
    "393": "Vermont",
    "394": "Virginie",
    "395": "Washington",
    "396": "Virginie occidentale",
    "397": "Wisconsin",
    "398": "Wyoming",
    "399": "Abruzzes",
    "400": "Vallée d`Aoste",
    "401": "Pouilles",
    "402": "Basilicate",
    "403": "Calabre",
    "404": "Campanie",
    "405": "Émilie-Romagne",
    "406": "Frioul-Vénétie Julienne",
    "407": "Latium",
    "408": "Ligurie",
    "409": "Lombardie",
    "410": "Marche",
    "411": "Molise",
    "412": "Piedmont",
    "413": "Sardaigne",
    "414": "Sicile",
    "415": "Trentin Haut-Adige",
    "416": "Toscane",
    "417": "Ombrie",
    "418": "Vénétie",
    "419": "Acre",
    "420": "Alagoas",
    "421": "Amapá",
    "422": "Amazonas",
    "423": "Bahia",
    "424": "Ceará",
    "425": "District fédéral",
    "426": "Espírito Santo",
    "427": "Goias",
    "428": "Maranhão",
    "429": "Mato Grosso",
    "430": "Mato Grosso do Sul",
    "431": "Minas Gerais",
    "432": "Pará",
    "433": "Paraíba",
    "434": "Parana",
    "435": "Pernambuco",
    "436": "Piauí",
    "437": "Rio de Janeiro",
    "438": "Rio Grande do Norte",
    "439": "Rio Grande do Sul",
    "440": "Rondônia",
    "441": "Roraima",
    "442": "Santa Catarina",
    "443": "São Paulo",
    "444": "Sergipe",
    "445": "Tocantins",
    "446": "Alsace-Champagne-Ardenne-Lorraine",
    "447": "Aquitaine-Limousin-Poitou-Charentes",
    "448": "Auvergne - Rhône-Alpes",
    "449": "Bourgogne - Franche-Comté",
    "450": "Bretagne",
    "451": "Centre - Val de Loire",
    "452": "Corse",
    "453": "Île-de-France",
    "454": "Languedoc-Roussillon-Midi-Pyrénées",
    "455": "Nord-Pas-de-Calais-Picardie",
    "456": "Normandie",
    "457": "Pays de la Loire",
    "458": "Provence-Alpes-Côte d`Azur",
    Territory: "Territory",
    Anhui: "Anhui",
    Beijing: "Beijing",
    "Chinese Taipei": "Chinese Taipei",
    "Chong Qing": "Chong Qing",
    Fujian: "Fujian",
    Gansu: "Gansu",
    Guangdong: "Guangdong",
    Guangxi: "Guangxi",
    Guizhou: "Guizhou",
    Hainan: "Hainan",
    Hebei: "Hebei",
    Heilongjiang: "Heilongjiang",
    Henan: "Henan",
    "Hong Kong": "Hong Kong",
    Hubei: "Hubei",
    Hunan: "Hunan",
    Jiangsu: "Jiangsu",
    Jiangxi: "Jiangxi",
    Jilin: "Jilin",
    Liaoning: "Liaoning",
    Macao: "Macao",
    "Nei Mongol": "Nei Mongol",
    Ningxia: "Ningxia",
    Qinghai: "Qinghai",
    Shaanxi: "Shaanxi",
    Shandong: "Shandong",
    Shanghai: "Shanghai",
    Shanxi: "Shanxi",
    Sichuan: "Sichuan",
    Tianjin: "Tianjin",
    Xinjiang: "Xinjiang",
    Xizang: "Xizang",
    Yunnan: "Yunnan",
    Zhejiang: "Zhejiang",
  },
};

export default countriesAndRegions;
